import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-propertygrid',
  templateUrl: './change-propertygrid.component.html',
  styleUrls: ['./change-propertygrid.component.css']
})
export class ChangePropertygridComponent implements OnInit {
  title = "Change Property";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/change-property/change-propertygrid/change-propertygrid.component.ts